import React from 'react'
import eqxApiInstance from '../classes/eqxApi'
import eqxEndpoint from '../classes/eqxEndpoint'

/**
 *
 */
function useApiEndpoint<ResponseType, InputType = null>(
    api: eqxApiInstance,
    endpoint?: eqxEndpoint<ResponseType, InputType> | string,
    allowRequest: boolean = true,
    data?: InputType
): {
    response: ResponseType | null
    loading: boolean
    error: string | null
    status: 'not-requested' | 'loading' | 'error' | 'success'
    set: (response: ResponseType | null) => void
    reset: (quietly?: boolean) => void
} {
    if (typeof endpoint == 'string') endpoint = new eqxEndpoint<ResponseType, InputType>(endpoint)
    const [requested, setRequested] = React.useState<boolean>(false)
    const [error, setError] = React.useState<string | null>(null)
    const [response, setResponse] = React.useState<any>(null)
    const [loading, setLoading] = React.useState<boolean>(true)

    //because it's a hook, hard to not call it if endpoint is optional. This allows us to proceed with a blank endpoint, so that later code can stop the component
    if (!endpoint)
        return {
            response: null,
            loading: false,
            error: null,
            status: 'not-requested',
            set: () => {},
            reset: (quietly: boolean = false) => {},
        }

    if (!requested && allowRequest) {
        setRequested(true)
        endpoint
            .execute(api, data)
            .then((theResponse) => {
                setResponse(theResponse as ResponseType)
                setLoading(false)
            })
            .catch((error) => {
                if (!error) error = 'Unknown error'
                setError(error)
                setLoading(false)
            })
    }
    return {
        response,
        loading,
        error,
        status: !requested ? 'not-requested' : loading ? 'loading' : error ? 'error' : 'success',
        set: setResponse,
        reset: (quietly: boolean = false) => {
            setRequested(false)
            setError(null)
            if (!quietly) setResponse(null)
            setLoading(true)
        },
    }
}

export default useApiEndpoint
